import { configureStore, Action } from '@reduxjs/toolkit'
import { ThunkAction } from 'redux-thunk'

import rootReducer from './rootReducer'

// Store per Redux inizializzato con il rootReducer
const store = configureStore({
  reducer: rootReducer
})

// Solo per sviluppo (devtools) per hot reload veloce dei reducers
if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./rootReducer', () => {
    const newRootReducer = require('./rootReducer').default
    store.replaceReducer(newRootReducer)
  })
}

// Type per il dispatch delle azioni
export type AppDispatch = typeof store.dispatch
// Type per l'AppThunk (operazioni asincrone es. call API)
export type AppThunk = ThunkAction<void, RootState, null, Action<string>>

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>


export default store